import commonMixin from './_common';

/**
 * デプロイ予約有無確認mixin
 */
export default {
    data() {
        return {
        };
    },
    mixins: [
        commonMixin,
    ],
    methods: {
        // 「反映予約」有無を返却する
        existsDeployReservation: async function () {
            try {
                this.$_loading();
                const response = await axios.get('/exists_deploy_reservation', {
                });
                if (response.data.status === 'OK') {
                    return response.data.exists;
                }
            } finally {
                this.$_unloading();
            }
        },
    }
};
